const MAX_FILE_SIZE = 2 * 1024 * 1024; // 2MB

export async function compressImage(file: File): Promise<File> {
  if (file.size <= MAX_FILE_SIZE) {
    return file;
  }

  const bitmap = await createImageBitmap(file);
  const { width, height } = bitmap;

  const maxDim = 1024;
  let newWidth = width;
  let newHeight = height;
  if (width > maxDim || height > maxDim) {
    const scale = Math.min(maxDim / width, maxDim / height);
    newWidth = Math.round(width * scale);
    newHeight = Math.round(height * scale);
  }

  const canvas = new OffscreenCanvas(newWidth, newHeight);
  // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
  const ctx = canvas.getContext("2d")!;
  ctx.drawImage(bitmap, 0, 0, newWidth, newHeight);
  bitmap.close();

  let best: Blob = await canvas.convertToBlob({
    type: "image/jpeg",
    quality: 0.8,
  });
  if (best.size > MAX_FILE_SIZE) {
    best = await canvas.convertToBlob({ type: "image/jpeg", quality: 0.5 });
  }

  return new File([best], file.name.replace(/\.\w+$/, ".jpg"), {
    type: "image/jpeg",
  });
}
